﻿<template>
    <aside class="mb-card bd-summary">
        <div class="mb-card-body">
            <h3 class="mb-card-title">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <rect x="2" y="5" width="20" height="14" rx="2" /><path d="M2 10h20" />
                </svg>
                Booking summary
            </h3>

            <booking_line :trip="trip" v-for="(trip, index) in $store.getters.get_Booking?.trips" :key="index"></booking_line>

            <dl class="bd-totals">
                <template v-if="Display_Discount()">
                    <div>
                        <dt>Trip price</dt>
                        <dd>{{get_Trip_Price()}}</dd>
                    </div>
                    <div class="is-discount">
                        <dt>Discount</dt>
                        <dd>−{{get_Trip_Discount()}}</dd>
                    </div>
                </template>
                <div class="is-total">
                    <dt>Total</dt>
                    <dd>{{get_Trip_Price()}}</dd>
                </div>
                <div>
                    <dt>Nett</dt>
                    <dd>{{get_Trip_Nett_Price()}}</dd>
                </div>
                <div class="is-paid">
                    <dt>Paid</dt>
                    <dd>{{get_Trip_Paid()}}</dd>
                </div>
            </dl>

            <div class="bd-balance" :class="{ 'is-settled': !has_Outstanding_Balance() }">
                <span>{{ has_Outstanding_Balance() ? 'Balance remaining' : 'Paid in full' }}</span>
                <strong>{{get_Trip_Balance()}}</strong>
            </div>

            <div class="bd-actions">
                <button v-if="has_Outstanding_Balance()" type="button" class="button button-pink-book full" @click="Make_Payment()">Make Payment</button>
                <button type="button" class="bd-btn-danger" @click="Cancel_Booking()">Cancel Booking</button>
            </div>
        </div>

        <teleport to="body">
        <div class="bd-modal-overlay" v-if="!Hide_Cancel" @click.self="Hide_Cancel = true">
            <div class="bd-modal" role="dialog" aria-modal="true" aria-labelledby="cancel-booking-title">
                <booking_cancel></booking_cancel>
                <div class="bd-modal-actions">
                    <button type="button" class="bd-btn-plain" @click="Hide_Cancel = true">Keep booking</button>
                    <button type="button" class="bd-btn-danger is-solid" :disabled="Cancelling_Booking" @click="Action_Cancel_Booking()">
                        <svg v-if="Cancelling_Booking" class="mb-spinner" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true">
                            <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="3" opacity="0.25" />
                            <path d="M22 12a10 10 0 0 0-10-10" stroke="currentColor" stroke-width="3" stroke-linecap="round" />
                        </svg>
                        Cancel Booking
                    </button>
                </div>
            </div>
        </div>
        </teleport>
    </aside>
</template>
<script lang="ts" src="./booking_details.ts"></script>
